<template>
  <div class="p-2 sm:p-4 text-lexend overflow-x-hidden min-h-screen bg-gray-50 dark:bg-gray-900/50">
    <!-- Encabezado -->
    <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 sm:gap-4 mb-3 sm:mb-5 mt-1">
      <div class="animate-fadeIn w-full sm:w-auto">
        <div class="flex items-center gap-2 mb-1">
          <div class="w-8 h-1 bg-indigo-600 rounded-full"></div>
          <span class="text-[10px] sm:text-xs font-black text-indigo-600 tracking-widest">Panel de Control</span>
        </div>
        <h1 class="text-xl sm:text-3xl font-black text-gray-900 dark:text-white tracking-tight flex items-center flex-wrap gap-2">
          Gestión de Ventas
          <span class="px-2 sm:px-3 py-0.5 bg-indigo-100 dark:bg-indigo-900/40 text-indigo-600 dark:text-indigo-300 text-xs sm:text-sm font-black rounded-lg border border-indigo-200 dark:border-indigo-800">
            {{ ventas.length }}
          </span>
        </h1>
        <p class="text-[10px] sm:text-xs text-gray-500 dark:text-gray-400 mt-0.5">Historial de transacciones y cobros</p>
      </div>
      
      <div class="flex items-center gap-2 w-full sm:w-auto">
        <button @click="refreshVentas" class="px-3 sm:px-4 py-2 bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300 rounded-xl font-black text-[10px] sm:text-xs tracking-widest transition-all shadow-md flex items-center gap-2 border border-gray-200 dark:border-gray-600">
          <Icon icon="mdi:refresh" class="text-base sm:text-lg" />
          <span class="hidden sm:inline">Actualizar</span>
          <span class="sm:hidden">Actualizar</span>
        </button>
        
        <button @click="$router.push('/ventas/nueva')" class="px-3 sm:px-6 py-2 bg-gradient-to-r from-green-500 to-emerald-500 text-white rounded-xl font-black text-[10px] sm:text-xs tracking-widest transition-all shadow-lg shadow-green-200 dark:shadow-none flex items-center gap-2">
          <Icon icon="mdi:plus" class="text-base sm:text-xl" />
          <span class="hidden sm:inline">Nueva Venta</span>
          <span class="sm:hidden">Nueva</span>
        </button>
      </div>
    </div>

    <!-- Panel de Filtros Compacto -->
    <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-200 dark:border-gray-700 mb-3 sm:mb-5 overflow-hidden animate-fadeInUp">
      <div class="p-3 border-b border-gray-100 dark:border-gray-700 flex items-center justify-between bg-gray-50/50 dark:bg-gray-800/50">
        <div class="flex items-center gap-2">
          <Icon icon="mdi:filter-variant" class="text-blue-500 text-lg" />
          <h2 class="text-[10px] sm:text-xs font-bold text-gray-700 dark:text-white uppercase tracking-wider">Filtros de Búsqueda</h2>
          <span v-if="filtrosActivos" class="px-1.5 py-0.5 bg-blue-100 text-blue-600 text-[8px] sm:text-[9px] font-bold rounded uppercase">Activos</span>
        </div>
        <button @click="toggleFiltros" class="text-[9px] sm:text-[10px] font-bold text-blue-600 hover:text-blue-700 flex items-center gap-1 uppercase">
          <Icon :icon="mostrarFiltros ? 'mdi:chevron-up' : 'mdi:chevron-down'" class="text-base" />
          {{ mostrarFiltros ? 'Contraer' : 'Expandir' }}
        </button>
      </div>

      <div v-if="mostrarFiltros" class="p-3 sm:p-4 bg-white dark:bg-gray-800">
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-12 gap-2 sm:gap-3">
          <div class="sm:col-span-1 lg:col-span-3">
            <label class="block text-[9px] sm:text-[10px] font-bold text-gray-400 uppercase mb-1 ml-1">Factura</label>
            <input v-model="filtro.numeroFactura" type="text" placeholder="FAC-000" class="w-full px-3 py-1.5 bg-gray-50 dark:bg-gray-700/50 border border-gray-200 dark:border-gray-600 rounded-lg text-xs focus:border-blue-500 outline-none transition-all" @input="filtrarVentas" />
          </div>
          <div class="sm:col-span-1 lg:col-span-3">
            <label class="block text-[9px] sm:text-[10px] font-bold text-gray-400 uppercase mb-1 ml-1">Vendedor</label>
            <select v-model="filtro.idVendedor" class="w-full px-2 py-1.5 bg-gray-50 dark:bg-gray-700/50 border border-gray-200 dark:border-gray-600 rounded-lg text-xs focus:border-blue-500 outline-none cursor-pointer" @change="filtrarVentas">
              <option value="">Todos los vendedores</option>
              <option v-for="vendedor in vendedoresUnicos" :key="vendedor.idVendedor" :value="vendedor.idVendedor">{{ vendedor.nombreCompleto }}</option>
            </select>
          </div>
          <div class="sm:col-span-2 lg:col-span-4">
            <label class="block text-[9px] sm:text-[10px] font-bold text-gray-400 uppercase mb-1 ml-1">Rango de Fecha</label>
            <div class="flex items-center gap-1">
              <input v-model="filtro.fechaDesde" type="date" class="w-full px-2 py-1.5 bg-gray-50 dark:bg-gray-700/50 border border-gray-200 dark:border-gray-600 rounded-lg text-[10px] focus:border-blue-500 outline-none" @change="filtrarVentas" />
              <span class="text-gray-300 text-xs">-</span>
              <input v-model="filtro.fechaHasta" type="date" class="w-full px-2 py-1.5 bg-gray-50 dark:bg-gray-700/50 border border-gray-200 dark:border-gray-600 rounded-lg text-[10px] focus:border-blue-500 outline-none" @change="filtrarVentas" />
            </div>
          </div>
          <div class="sm:col-span-2 lg:col-span-2 flex items-end gap-2">
            <button @click="resetFiltros" class="flex-1 px-3 py-1.5 text-[9px] sm:text-[10px] font-black uppercase text-gray-400 hover:text-gray-600 transition-colors border border-gray-200 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700">Limpiar</button>
            <button @click="aplicarFiltrosRapidos" class="flex-1 px-3 py-1.5 bg-blue-600 text-white rounded-lg text-[9px] sm:text-[10px] font-black uppercase shadow-md hover:bg-blue-700 transition-all flex items-center justify-center gap-1.5">
              <Icon icon="mdi:filter-check" class="text-sm" />
              <span class="hidden sm:inline">Aplicar</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Tabla de ventas -->
    <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-md border border-gray-200 dark:border-gray-700 overflow-hidden animate-fadeInUp delay-100">
      <!-- Vista móvil (cards) -->
      <div class="block sm:hidden">
        <div v-if="cargando" class="p-8 text-center">
          <div class="inline-block animate-spin rounded-full h-8 w-8 border-4 border-blue-500 border-t-transparent"></div>
          <p class="mt-2 text-gray-600 dark:text-gray-400 text-sm">Cargando ventas...</p>
        </div>
        
        <div v-else-if="ventasPaginadas.length === 0" class="p-8 text-center">
          <Icon icon="mdi:file-search-outline" class="text-5xl text-gray-300 mx-auto mb-3" />
          <p class="text-gray-600 dark:text-gray-400 font-bold">No hay ventas</p>
          <button @click="resetFiltros" class="mt-2 text-indigo-600 text-sm hover:underline font-bold">Limpiar filtros</button>
        </div>
        
        <div v-else class="divide-y divide-gray-200 dark:divide-gray-700">
          <div v-for="venta in ventasPaginadas" :key="venta.idVenta" 
               class="p-4 hover:bg-gray-50 dark:hover:bg-gray-700/50 cursor-pointer transition-colors">
            
            <div class="flex justify-between items-start mb-2">
              <div class="flex-1 min-w-0">
                <div class="font-semibold text-blue-600 dark:text-blue-400 truncate flex items-center gap-2 text-sm">
                  {{ venta.numeroFactura }}
                  <span v-if="venta.tipoVenta" 
                        class="px-2 py-0.5 text-[8px] rounded-full whitespace-nowrap font-black"
                        :class="getTipoVentaClasses(venta.tipoVenta)">
                    {{ formatearTipoVentaConCredito(venta.tipoVenta, venta.idTipoCredito) }}
                  </span>
                </div>
                <div class="text-[10px] text-gray-500 dark:text-gray-400 font-bold">{{ formatFecha(venta.fechaVenta) }}</div>
              </div>
            </div>
            
            <div class="grid grid-cols-2 gap-2 mb-2 text-xs">
              <div>
                <span class="text-[9px] text-gray-500 dark:text-gray-400 block uppercase font-bold">Cliente</span>
                <span class="font-bold truncate block text-gray-800 dark:text-white">{{ truncarTexto(venta.clienteNombre, 20) }}</span>
              </div>
              <div>
                <span class="text-[9px] text-gray-500 dark:text-gray-400 block uppercase font-bold">Vendedor</span>
                <span class="font-bold truncate block text-gray-800 dark:text-white">{{ truncarTexto(venta.vendedorNombre, 20) }}</span>
              </div>
            </div>
            
            <div class="text-[10px] text-gray-500 dark:text-gray-400 mb-2 line-clamp-2 font-bold">
              <Icon icon="mdi:package-variant" class="inline mr-1" />
              {{ venta.productos || 'Sin detalles' }}
            </div>
            
            <div class="flex justify-between items-center">
              <div class="flex items-center">
                <div class="w-6 h-6 bg-amber-100 dark:bg-amber-900/30 rounded-full flex items-center justify-center mr-2">
                  <Icon :icon="getMetodoPagoIcon(venta.metodoPago)" class="text-amber-600 dark:text-amber-400 text-xs" />
                </div>
                <span class="text-[10px] font-bold">{{ formatearMetodoPagoVenta(venta) || 'N/A' }}</span>
              </div>
              <div class="text-right">
                <div class="font-black text-base text-gray-800 dark:text-white">
                  ${{ formatNumber(venta.totalUsd) }}
                </div>
                <div v-if="esVentaCredito(venta)" class="text-[9px] font-black text-green-600 dark:text-green-400 uppercase">
                  Cobrado: ${{ formatNumber(sumarPagos(venta)) }}
                </div>
              </div>
            </div>
            
            <div class="flex justify-end gap-1 mt-3 pt-2 border-t border-gray-100 dark:border-gray-700">
              <button @click.stop="verDetalles(venta)" class="p-1.5 text-blue-600 hover:bg-blue-50 dark:hover:bg-blue-900/20 rounded-lg transition-colors" title="Ver Detalles">
                <Icon icon="mdi:eye-outline" class="text-base" />
              </button>
              <button @click.stop="imprimirVenta(venta)" class="p-1.5 text-indigo-600 hover:bg-indigo-50 dark:hover:bg-indigo-900/20 rounded-lg transition-colors" title="Imprimir Ticket">
                <Icon icon="mdi:printer" class="text-base" />
              </button>
              <button 
                v-if="tieneIva(venta)"
                @click.stop="imprimirFacturaDigital(venta)" 
                class="p-1.5 text-emerald-600 hover:bg-emerald-50 dark:hover:bg-emerald-900/20 rounded-lg transition-colors" 
                title="Factura Digital (PDF)">
                <Icon icon="mdi:file-pdf-box" class="text-base" />
              </button>
              <button v-if="venta.estado === 'Pendiente'" @click.stop="abrirModalPago(venta)" class="p-1.5 text-green-600 hover:bg-green-50 dark:hover:bg-green-900/20 rounded-lg transition-colors" title="Registrar Pago">
                <Icon icon="mdi:check-circle-outline" class="text-base" />
              </button>
              <button @click.stop="abrirModalEliminar(venta)" class="p-1.5 text-red-600 hover:bg-red-50 dark:hover:bg-red-900/20 rounded-lg transition-colors" title="Anular Venta">
                <Icon icon="mdi:delete-outline" class="text-base" />
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Vista desktop (tabla) -->
      <div class="hidden sm:block overflow-x-auto custom-scrollbar">
        <table class="w-full text-left border-collapse">
          <thead>
            <tr class="bg-gray-50 dark:bg-gray-900/50 border-b border-gray-200 dark:border-gray-700">
              <th class="px-5 py-4 text-[11px] font-black text-gray-400 tracking-widest">Factura</th>
              <th class="px-5 py-4 text-[11px] font-black text-gray-400 tracking-widest">Tipo</th>
              <th class="px-5 py-4 text-[11px] font-black text-gray-400 tracking-widest">Cliente</th>
              <th class="px-5 py-4 text-[11px] font-black text-gray-400 tracking-widest">Vendedor</th>
              <th class="px-5 py-4 text-[11px] font-black text-gray-400 tracking-widest">Método</th>
              <th class="px-5 py-4 text-[11px] font-black text-gray-400 tracking-widest">Total / Cobrado</th>
              <th class="px-5 py-4 text-[11px] font-black text-gray-400 tracking-widest">Productos</th>
              <th class="px-5 py-4 text-[11px] font-black text-gray-400 tracking-widest text-center">Acciones</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-100 dark:divide-gray-700">
            <tr v-if="cargando" v-for="i in 5" :key="'load-'+i" class="animate-pulse">
              <td colspan="8" class="px-5 py-4"><div class="h-4 bg-gray-100 dark:bg-gray-700 rounded w-full"></div></td>
            </tr>
            <tr v-if="!cargando && ventasFiltradas.length === 0">
              <td colspan="8" class="px-5 py-16 text-center">
                <div class="flex flex-col items-center opacity-30 select-none">
                  <Icon icon="mdi:file-search-outline" class="text-7xl mb-3" />
                  <h4 class="text-xl font-black text-gray-400 tracking-widest">No hay ventas</h4>
                </div>
              </td>
            </tr>
            <tr v-for="venta in ventasPaginadas" :key="venta.idVenta"
                @click="verDetalles(venta)"
                class="hover:bg-indigo-50/30 dark:hover:bg-gray-700/30 transition-all group cursor-pointer">
              <td class="px-5 py-4">
                <div class="font-bold text-gray-900 dark:text-white text-sm">{{ venta.numeroFactura }}</div>
                <div class="text-[10px] text-gray-500 font-bold">{{ formatFecha(venta.fechaVenta) }}</div>
              </td>
              <td class="px-5 py-4">
                <span v-if="venta.tipoVenta" 
                      class="px-2.5 py-1 text-[9px] rounded-full font-black uppercase"
                      :class="getTipoVentaClasses(venta.tipoVenta)">
                  {{ formatearTipoVentaConCredito(venta.tipoVenta, venta.idTipoCredito) }}
                </span>
                <span v-else class="text-gray-400 text-xs font-bold">-</span>
              </td>
              <td class="px-5 py-4">
                <div class="flex items-center gap-2">
                  <div class="w-7 h-7 bg-gray-100 dark:bg-gray-700 rounded-lg flex items-center justify-center font-black text-gray-500 text-xs">
                    {{ (venta.clienteNombre || '?').charAt(0) }}
                  </div>
                  <span class="font-bold text-gray-900 dark:text-white text-xs truncate max-w-[150px]">{{ truncarTexto(venta.clienteNombre, 25) }}</span>
                </div>
              </td>
              <td class="px-5 py-4">
                <div class="flex items-center gap-1.5">
                  <Icon icon="mdi:account-tie" class="text-gray-400 text-sm" />
                  <span class="font-bold text-gray-600 dark:text-gray-300 text-xs">{{ truncarTexto(venta.vendedorNombre, 20) }}</span>
                </div>
              </td>
              <td class="px-5 py-4">
                <div class="flex items-center gap-1.5">
                  <Icon :icon="getMetodoPagoIcon(venta.metodoPago)" class="text-amber-600 text-sm" />
                  <span v-if="venta.cargandoPago" class="text-gray-400 text-xs font-bold">Cargando...</span>
                  <span v-else class="font-bold text-gray-800 dark:text-white text-xs">{{ formatearMetodoPagoVenta(venta) || '—' }}</span>
                </div>
              </td>
              <td class="px-5 py-4">
                <div class="font-black text-gray-900 dark:text-white text-sm">${{ formatNumber(venta.totalUsd) }}</div>
                <div v-if="esVentaCredito(venta)" class="text-[9px] font-black text-green-600 dark:text-green-400 uppercase tracking-tighter">
                  Cobrado: ${{ formatNumber(sumarPagos(venta)) }}
                </div>
              </td>
              <td class="px-5 py-4">
                <span class="text-[10px] font-bold text-gray-500 dark:text-gray-400 max-w-[150px] truncate block" :title="venta.productos">{{ venta.productos || '—' }}</span>
              </td>
              <td class="px-5 py-4">
                <div class="flex items-center justify-center gap-0.5 flex-nowrap whitespace-nowrap">
                  <button @click.stop="verDetalles(venta)" class="p-1.5 bg-blue-50 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400 rounded-lg hover:bg-blue-600 hover:text-white transition-all shadow-sm flex-shrink-0" title="Ver Detalles">
                    <Icon icon="mdi:eye-outline" class="text-base" />
                  </button>
                  <button @click.stop="imprimirVenta(venta)" class="p-1.5 bg-indigo-50 dark:bg-indigo-900/30 text-indigo-600 dark:text-indigo-400 rounded-lg hover:bg-indigo-600 hover:text-white transition-all shadow-sm flex-shrink-0" title="Imprimir Ticket">
                    <Icon icon="mdi:printer" class="text-base" />
                  </button>
                  <button 
                    v-if="tieneIva(venta)"
                    @click.stop="imprimirFacturaDigital(venta)" 
                    class="p-1.5 bg-emerald-50 dark:bg-emerald-900/30 text-emerald-600 dark:text-emerald-400 rounded-lg hover:bg-emerald-600 hover:text-white transition-all shadow-sm flex-shrink-0" 
                    title="Factura Digital (PDF)">
                    <Icon icon="mdi:file-pdf-box" class="text-base" />
                  </button>
                  <button v-if="venta.estado === 'Pendiente'" @click.stop="abrirModalPago(venta)" class="p-1.5 bg-green-50 dark:bg-green-900/30 text-green-600 dark:text-green-400 rounded-lg hover:bg-green-600 hover:text-white transition-all shadow-sm flex-shrink-0" title="Registrar Pago">
                    <Icon icon="mdi:check-circle-outline" class="text-base" />
                  </button>
                  <button @click.stop="abrirModalEliminar(venta)" class="p-1.5 bg-red-50 dark:bg-red-900/30 text-red-600 dark:text-red-400 rounded-lg hover:bg-red-600 hover:text-white transition-all shadow-sm flex-shrink-0" title="Anular Venta">
                    <Icon icon="mdi:delete-outline" class="text-base" />
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Paginación -->
      <div v-if="ventasFiltradas.length > itemsPorPaginaEfectivo" class="bg-gray-50/50 dark:bg-gray-800/50 px-3 sm:px-5 py-3 border-t border-gray-200 dark:border-gray-700 flex flex-col sm:flex-row items-center justify-between gap-3">
        <div class="text-[9px] sm:text-[11px] font-black text-gray-400 uppercase tracking-widest text-center sm:text-left">
          Mostrando {{ startIndex + 1 }} - {{ Math.min(endIndex, ventasFiltradas.length) }} <span class="mx-1 text-gray-300">|</span> Total: {{ ventasFiltradas.length }}
        </div>
        <div class="flex items-center gap-1 flex-wrap justify-center">
          <button @click="paginaAnterior" :disabled="paginaActual === 1" :class="['p-1.5 rounded-lg border transition-all', paginaActual === 1 ? 'opacity-30 cursor-not-allowed border-gray-200 dark:border-gray-700' : 'hover:bg-white dark:hover:bg-gray-700 border-gray-200 dark:border-gray-600 shadow-sm']">
            <Icon icon="mdi:chevron-left" class="text-base sm:text-xl" />
          </button>
          
          <div class="hidden sm:flex items-center gap-0.5 sm:gap-1 mx-1 sm:mx-2">
            <button v-for="page in paginasVisiblesMobile" :key="page" @click="irAPagina(page)" :class="['w-7 h-7 sm:w-9 sm:h-9 rounded-lg text-[10px] sm:text-xs font-black transition-all flex items-center justify-center', paginaActual === page ? 'bg-blue-600 text-white shadow-md shadow-blue-500/30' : 'text-gray-500 hover:bg-white dark:hover:bg-gray-700 border border-transparent hover:border-gray-200 dark:hover:border-gray-600']">
              {{ page }}
            </button>
          </div>
          <span class="sm:hidden text-xs font-black text-gray-600 dark:text-gray-300 px-2">{{ paginaActual }} / {{ totalPaginas }}</span>

          <button @click="paginaSiguiente" :disabled="paginaActual === totalPaginas" :class="['p-1.5 rounded-lg border transition-all', paginaActual === totalPaginas ? 'opacity-30 cursor-not-allowed border-gray-200 dark:border-gray-700' : 'hover:bg-white dark:hover:bg-gray-700 border-gray-200 dark:border-gray-600 shadow-sm']">
            <Icon icon="mdi:chevron-right" class="text-base sm:text-xl" />
          </button>
        </div>
      </div>
    </div>

    <!-- ============================================ -->
    <!-- MODAL DE PAGO -->
    <!-- ============================================ -->
    <Teleport to="body">
      <div v-if="modalPago.show" class="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center p-3 sm:p-4 z-[9999]" @click.self="cerrarModalPago">
        <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl w-full max-w-sm overflow-hidden animate-zoomIn">
          <div class="bg-gradient-to-r from-green-600 to-emerald-600 px-4 sm:px-6 py-3 sm:py-4 flex items-center justify-between">
            <div class="flex items-center gap-2 sm:gap-3">
              <div class="p-1.5 sm:p-2 bg-white/20 rounded-xl">
                <Icon icon="mdi:check-circle" class="text-white text-lg sm:text-xl" />
              </div>
              <div>
                <h3 class="text-sm sm:text-base font-bold text-white uppercase tracking-wider">Confirmar Pago</h3>
                <p class="text-[8px] sm:text-[10px] text-green-100 font-bold">Procesar liquidación de factura</p>
              </div>
            </div>
            <button @click="cerrarModalPago" class="p-1.5 bg-white/10 hover:bg-white/20 rounded-lg transition-all">
              <Icon icon="mdi:close" class="text-white text-lg sm:text-xl" />
            </button>
          </div>

          <div class="p-4 sm:p-6">
            <div class="bg-gray-50 dark:bg-gray-700/30 p-3 sm:p-4 rounded-xl border border-gray-100 dark:border-gray-700 text-left mb-4 sm:mb-6">
              <div class="flex justify-between text-[9px] sm:text-[10px] font-bold text-gray-400 uppercase mb-1">
                <span>Factura</span>
                <span class="text-gray-800 dark:text-white font-black text-xs sm:text-sm">{{ ventaParaPago?.numeroFactura }}</span>
              </div>
              <div class="flex justify-between text-[9px] sm:text-[10px] font-bold text-gray-400 uppercase">
                <span>Total a Pagar</span>
                <span class="text-green-600 text-sm sm:text-base font-black">${{ formatNumber(ventaParaPago?.totalUsd) }}</span>
              </div>
            </div>

            <div class="flex flex-col sm:flex-row gap-2">
              <button @click="cerrarModalPago" class="w-full sm:flex-1 px-4 py-2 text-[10px] sm:text-xs font-black text-gray-400 uppercase border border-gray-100 dark:border-gray-700 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 transition-all">Cancelar</button>
              <button @click="confirmarPago" :disabled="procesandoPago" class="w-full sm:flex-1 px-4 py-2 bg-green-600 text-white rounded-lg text-[10px] sm:text-xs font-black uppercase shadow-md hover:bg-green-700 disabled:opacity-50 transition-all flex items-center justify-center gap-2">
                <Icon v-if="procesandoPago" icon="mdi:loading" class="animate-spin" />
                {{ procesandoPago ? 'Procesando...' : 'Confirmar' }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </Teleport>

    <!-- ============================================ -->
    <!-- MODAL DE ELIMINAR -->
    <!-- ============================================ -->
    <Teleport to="body">
      <div v-if="modalEliminar.show" class="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center p-3 sm:p-4 z-[10000]" @click.self="cerrarModalEliminar">
        <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl w-full max-w-sm overflow-hidden animate-zoomIn">
          <div class="bg-gradient-to-r from-red-600 to-rose-600 px-4 sm:px-6 py-3 sm:py-4 flex items-center justify-between">
            <div class="flex items-center gap-2 sm:gap-3">
              <div class="p-1.5 sm:p-2 bg-white/20 rounded-xl">
                <Icon icon="mdi:alert-circle" class="text-white text-lg sm:text-xl" />
              </div>
              <div>
                <h3 class="text-sm sm:text-base font-bold text-white uppercase tracking-wider">Anular Venta</h3>
                <p class="text-[8px] sm:text-[10px] text-red-100 font-bold">Esta acción es irreversible</p>
              </div>
            </div>
            <button @click="cerrarModalEliminar" class="p-1.5 bg-white/10 hover:bg-white/20 rounded-lg transition-all">
              <Icon icon="mdi:close" class="text-white text-lg sm:text-xl" />
            </button>
          </div>

          <div class="p-4 sm:p-6">
            <div class="bg-red-50/30 dark:bg-red-900/10 p-3 sm:p-4 rounded-xl border border-red-100 dark:border-red-900/30 text-center mb-4 sm:mb-6">
              <p class="text-[9px] sm:text-[10px] font-bold text-red-700 dark:text-red-400 uppercase mb-1 sm:mb-2">¿Estás seguro de anular la factura?</p>
              <p class="text-sm sm:text-base font-black text-gray-800 dark:text-white">{{ ventaParaEliminar?.numeroFactura }}</p>
            </div>

            <div class="flex flex-col sm:flex-row gap-2">
              <button @click="cerrarModalEliminar" class="w-full sm:flex-1 px-4 py-2 text-[10px] sm:text-xs font-black text-gray-400 uppercase border border-gray-100 dark:border-gray-700 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 transition-all">Cancelar</button>
              <button @click="confirmarEliminar" :disabled="procesandoEliminar" class="w-full sm:flex-1 px-4 py-2 bg-red-600 text-white rounded-lg text-[10px] sm:text-xs font-black uppercase shadow-md hover:bg-red-700 disabled:opacity-50 transition-all flex items-center justify-center gap-2">
                <Icon v-if="procesandoEliminar" icon="mdi:loading" class="animate-spin" />
                {{ procesandoEliminar ? 'Anulando...' : 'Confirmar Anulación' }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </Teleport>

    <!-- ============================================ -->
    <!-- MODAL DE DETALLES -->
    <!-- ============================================ -->
    <Teleport to="body">
      <div v-if="modalDetalles.show" class="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center p-2 sm:p-4 z-[9997]" @click.self="cerrarModalDetalles">
        <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl w-full max-w-4xl flex flex-col overflow-hidden animate-zoomIn max-h-[95vh]">
          <!-- Header -->
          <div class="bg-gradient-to-r from-blue-600 to-indigo-600 px-4 sm:px-6 py-3 sm:py-4 flex items-center justify-between flex-shrink-0">
            <div class="flex items-center gap-2 sm:gap-3">
              <div class="p-1.5 sm:p-2 bg-white/20 rounded-xl">
                <Icon icon="mdi:receipt-text" class="text-white text-lg sm:text-xl" />
              </div>
              <div>
                <h3 class="text-sm sm:text-base font-bold text-white uppercase tracking-wider">{{ ventaSeleccionada?.numeroFactura }}</h3>
                <p class="text-[8px] sm:text-[10px] text-blue-100 font-bold">{{ formatFechaCompleta(ventaSeleccionada?.fechaVenta) }}</p>
              </div>
            </div>
            <button @click="cerrarModalDetalles" class="p-1.5 bg-white/10 hover:bg-white/20 rounded-lg transition-all">
              <Icon icon="mdi:close" class="text-white text-lg sm:text-xl" />
            </button>
          </div>

          <!-- Tabs -->
          <div class="flex bg-gray-50 dark:bg-gray-800/50 border-b border-gray-200 dark:border-gray-700 p-1 flex-shrink-0">
            <button v-for="tab in ['resumen', 'productos', 'pagos', 'observaciones']" :key="tab" @click="tabActiva = tab" :class="['flex-1 py-1.5 sm:py-2 text-[8px] sm:text-[10px] font-black uppercase rounded-lg transition-all', tabActiva === tab ? 'bg-white dark:bg-gray-700 text-blue-600 shadow-sm' : 'text-gray-400 hover:text-gray-600']">{{ tab }}</button>
          </div>

          <!-- Content -->
          <div class="flex-1 overflow-y-auto p-3 sm:p-6 custom-scrollbar">
            <div v-if="tabActiva === 'resumen'" class="space-y-3 sm:space-y-4 animate-fadeIn">
              <div class="grid grid-cols-1 sm:grid-cols-2 gap-2 sm:gap-4">
                <div class="p-3 sm:p-4 bg-gray-50 dark:bg-gray-800/50 rounded-2xl border border-gray-100 dark:border-gray-700">
                  <span class="text-[9px] sm:text-[10px] font-bold text-gray-400 uppercase block mb-0.5 sm:mb-1">Cliente</span>
                  <span class="text-sm sm:text-base font-black text-gray-800 dark:text-white">{{ ventaSeleccionada?.clienteNombre || 'N/A' }}</span>
                </div>
                <div class="p-3 sm:p-4 bg-gray-50 dark:bg-gray-800/50 rounded-2xl border border-gray-100 dark:border-gray-700">
                  <span class="text-[9px] sm:text-[10px] font-bold text-gray-400 uppercase block mb-0.5 sm:mb-1">Vendedor</span>
                  <span class="text-sm sm:text-base font-black text-gray-800 dark:text-white">{{ ventaSeleccionada?.vendedorNombre || 'N/A' }}</span>
                </div>
              </div>
              <div class="grid grid-cols-2 sm:grid-cols-4 gap-2">
                <div class="p-2 sm:p-3 bg-blue-500/5 rounded-xl text-center">
                  <p class="text-[8px] sm:text-[9px] font-bold text-blue-400 uppercase mb-0.5">Total USD</p>
                  <p class="text-xs sm:text-sm font-black text-blue-600">${{ formatNumber(ventaSeleccionada?.totalUsd) }}</p>
                </div>
                <div class="p-2 sm:p-3 bg-green-500/5 rounded-xl text-center">
                  <p class="text-[8px] sm:text-[9px] font-bold text-green-400 uppercase mb-0.5">Estado</p>
                  <p class="text-[8px] sm:text-[10px] font-black text-green-600 uppercase">{{ ventaSeleccionada?.estado || 'Pendiente' }}</p>
                </div>
                <div class="p-2 sm:p-3 bg-amber-500/5 rounded-xl text-center col-span-2">
                  <p class="text-[8px] sm:text-[9px] font-bold text-amber-400 uppercase mb-0.5">Método</p>
                  <p class="text-[8px] sm:text-[10px] font-black text-amber-600 uppercase">{{ formatearMetodoPagoVenta(ventaSeleccionada) || 'Efectivo' }}</p>
                </div>
              </div>
            </div>

            <div v-if="tabActiva === 'productos'" class="space-y-2 animate-fadeIn">
              <div v-for="detalle in ventaSeleccionada?.detalles" :key="detalle.idVentaDetalle" class="flex items-center justify-between p-2 sm:p-3 bg-gray-50 dark:bg-gray-800/50 rounded-xl border border-gray-100 dark:border-gray-700">
                <div>
                  <p class="text-xs sm:text-sm font-bold text-gray-800 dark:text-white uppercase">{{ detalle.nombreProducto || detalle.productoNombre || 'Producto' }}</p>
                  <p class="text-[8px] sm:text-[10px] text-gray-400 font-bold uppercase">{{ detalle.cantidad }} Uds x ${{ formatNumber(detalle.precioUnitarioUsd) }}</p>
                </div>
                <p class="text-xs sm:text-sm font-black text-blue-600">${{ formatNumber(detalle.subtotalUsd) }}</p>
              </div>
              <div v-if="!ventaSeleccionada?.detalles?.length" class="text-center py-8">
                <Icon icon="mdi:package-off" class="text-4xl text-gray-300 mx-auto mb-2" />
                <p class="text-[10px] font-bold text-gray-400 uppercase">Sin productos registrados</p>
              </div>
            </div>

            <div v-if="tabActiva === 'pagos'" class="space-y-3 sm:space-y-4 animate-fadeIn">
              <div v-if="ventaSeleccionada?.pagos?.length > 0">
                <div v-for="(pago, i) in ventaSeleccionada.pagos" :key="i" class="p-3 sm:p-4 rounded-2xl bg-white dark:bg-gray-800 border border-gray-100 dark:border-gray-700 shadow-sm">
                  <div class="flex justify-between items-center border-b border-gray-50 dark:border-gray-700 pb-2 mb-2">
                    <span class="text-[9px] sm:text-[10px] font-black text-indigo-500 uppercase">Recibo #{{ i+1 }}</span>
                    <span class="text-[9px] sm:text-[10px] font-bold text-gray-400">{{ formatFechaCompleta(pago.fechaPago) }}</span>
                  </div>
                  <div class="flex justify-between items-end">
                    <div>
                      <p class="text-[9px] sm:text-[10px] font-bold text-gray-400 uppercase">Vía: {{ pago.tipoPago || 'Efectivo' }}</p>
                    </div>
                    <p class="text-base sm:text-lg font-black text-green-600">${{ formatNumber(pago.montoUsd) }}</p>
                  </div>
                </div>
              </div>
              <div v-else class="text-center py-8 sm:py-10">
                <Icon icon="mdi:cash-off" class="text-4xl sm:text-5xl text-gray-200 mx-auto mb-2" />
                <p class="text-[9px] sm:text-[10px] font-bold text-gray-400 uppercase">No se registran pagos</p>
              </div>
            </div>

            <div v-if="tabActiva === 'observaciones'" class="p-3 sm:p-4 bg-gray-50 dark:bg-gray-800/50 rounded-2xl min-h-[80px] sm:min-h-[100px] border border-gray-100 dark:border-gray-700 animate-fadeIn">
              <p class="text-xs sm:text-sm text-gray-600 dark:text-gray-300">{{ ventaSeleccionada?.observaciones || 'Sin comentarios adicionales.' }}</p>
            </div>
          </div>

          <!-- Footer -->
          <div class="px-4 sm:px-6 py-3 sm:py-4 border-t border-gray-100 dark:border-gray-700 bg-gray-50/50 dark:bg-gray-800/50 flex flex-col sm:flex-row justify-end gap-2 flex-shrink-0">
            <button @click="cerrarModalDetalles" class="w-full sm:w-auto px-4 sm:px-6 py-2 text-[10px] sm:text-xs font-black text-gray-400 uppercase hover:text-gray-600 transition-colors">Cerrar Detalle</button>
            <button 
              v-if="tieneIva(ventaSeleccionada)"
              @click="imprimirFacturaDigital(ventaSeleccionada)" 
              class="w-full sm:w-auto px-4 sm:px-6 py-2 bg-emerald-600 text-white rounded-xl text-[10px] sm:text-xs font-black uppercase shadow-md hover:bg-emerald-700 transition-all flex items-center justify-center gap-2">
              <Icon icon="mdi:file-pdf-box" />
              Factura Digital
            </button>
            <button v-if="ventaSeleccionada?.estado === 'Pendiente'" @click="abrirModalPago(ventaSeleccionada); cerrarModalDetalles()" class="w-full sm:w-auto px-6 sm:px-8 py-2 bg-green-600 text-white rounded-xl text-[10px] sm:text-xs font-black uppercase shadow-md hover:bg-green-700 transition-all">Registrar Pago</button>
          </div>
        </div>
      </div>
    </Teleport>
  </div>
</template>

<script>
import { Icon } from "@iconify/vue";
import { 
  obtenerVentas, 
  actualizarVenta, 
  eliminarVenta as eliminarVentaApi, 
  obtenerVentaConRelaciones,
  obtenerFacturaDigital,
  abrirFacturaPdf
} from '@/api/ventas.js';
import { obtenerPagosPorVenta } from '@/api/pagoVenta.js';
import { obtenerMetodosPagoActivos } from '@/api/metodosPago.api.js';
import { obtenerVendedores } from '@/api/vendedores.js';
import { obtenerClientes } from '@/api/clientes.js';
import { obtenerTasaActiva } from '@/api/tasas.js';
import { imprimirFactura } from '@/utils/facturaGenerator.js';
import { useToast } from "vue-toastification";
import { notificarVenta } from '@/utils/notificacionesHelper';

export default {
  name: 'VentasList',
  components: { Icon },
  setup() {
    const toast = useToast();
    return { toast };
  },
  data() {
    return {
      ventas: [],
      ventasFiltradas: [],
      cargando: false,
      cargandoPagos: false,
      
      filtro: {
        numeroFactura: '',
        idCliente: '',
        idVendedor: '',
        metodoPago: '',
        estado: '',
        fechaDesde: new Date().toLocaleDateString('sv-SE'),
        fechaHasta: ''
      },
      mostrarFiltros: true,
      
      paginaActual: 1,
      itemsPorPagina: 5,
      maxVisiblePages: 10,
      
      modalDetalles: { show: false },
      modalPago: { show: false },
      modalEliminar: { show: false },
      
      ventaSeleccionada: null,
      ventaParaPago: null,
      ventaParaEliminar: null,
      tabActiva: 'resumen',
      
      procesandoPago: false,
      procesandoEliminar: false,
      
      clientesMap: new Map(),
      clientesFullMap: new Map(),
      vendedoresMap: new Map(),
      clientesUnicos: [],
      vendedoresUnicos: [],
      metodosPago: []
    };
  },
  computed: {
    itemsPorPaginaEfectivo() {
      const hoy = new Date().toLocaleDateString('sv-SE');
      if (this.filtro.fechaDesde === hoy && !this.filtro.fechaHasta) {
        return this.ventasFiltradas.length || 1;
      }
      return this.itemsPorPagina;
    },
    totalPaginas() { 
      return Math.ceil(this.ventasFiltradas.length / this.itemsPorPaginaEfectivo); 
    },
    ventasPaginadas() { 
      const start = (this.paginaActual - 1) * this.itemsPorPaginaEfectivo; 
      return this.ventasFiltradas.slice(start, start + this.itemsPorPaginaEfectivo); 
    },
    startIndex() { return (this.paginaActual - 1) * this.itemsPorPaginaEfectivo; },
    endIndex() { return Math.min(this.startIndex + this.itemsPorPaginaEfectivo, this.ventasFiltradas.length); },
    paginasVisiblesMobile() {
      const total = this.totalPaginas, current = this.paginaActual;
      if (total <= 5) return Array.from({length: total}, (_, i) => i + 1);
      if (current <= 3) return [1, 2, 3, 4, 5];
      if (current >= total - 2) return [total - 4, total - 3, total - 2, total - 1, total];
      return [current - 2, current - 1, current, current + 1, current + 2];
    },
    filtrosActivos() { 
      return this.filtro.numeroFactura || this.filtro.idCliente || this.filtro.idVendedor || 
             this.filtro.metodoPago || this.filtro.estado || this.filtro.fechaDesde || this.filtro.fechaHasta; 
    }
  },
  watch: {
    $route(to, from) {
      this.cargarVentas();
    }
  },
  async mounted() { 
    // ✅ FASE 1: Datos maestros y ventas EN PARALELO (más rápido)
    const [_, ventasRes] = await Promise.all([
      this.cargarDatosMaestros(),
      obtenerVentas()
    ]);

    // ✅ FASE 2: Renderizar las ventas INMEDIATAMENTE (sin pagos)
    if (ventasRes.success) {
      this.ventas = (ventasRes.data || [])
        .map(v => this.normalizarVenta(v))
        .sort((a, b) => new Date(b.fechaVenta) - new Date(a.fechaVenta));
      this.filtrarVentas();
    } else {
      this.toast.error(ventasRes.error || 'No se pudieron cargar las ventas');
    }

    // ✅ FASE 3: Cargar los pagos en BACKGROUND (sin bloquear UI)
    this.cargarPagosDeVentas();

    // ✅ Abrir detalle desde URL si aplica
    const idVentaParam = this.$route.query.idVenta;
    if (idVentaParam) {
      this.abrirDetalleDesdeURL(idVentaParam);
    }
  },
  methods: {
    goToFirstPage() { this.paginaActual = 1; },
    goToLastPage() { this.paginaActual = this.totalPaginas; },
    
    async abrirDetalleDesdeURL(id) {
      try {
        const idVenta = parseInt(id);
        const venta = this.ventas.find(v => v.idVenta === idVenta);
        if (venta) {
          this.verDetalles(venta);
        } else {
          const res = await obtenerVentaConRelaciones(idVenta);
          if (res.success && res.data) {
            const ventaNormalizada = this.normalizarVenta(res.data);
            this.verDetalles(ventaNormalizada);
          }
        }
      } catch (e) {
        console.error('Error al abrir detalle desde URL:', e);
      }
    },
    
    normalizarVenta(venta) {
      const clienteNombre = this.clientesMap.get(venta.idCliente) || `Cliente ${venta.idCliente}`;
      const vendedorNombre = this.vendedoresMap.get(venta.idVendedor) || `Vendedor ${venta.idVendedor}`;
      
      return {
        idVenta: venta.idVenta,
        numeroFactura: venta.numeroFactura,
        fechaVenta: venta.fechaVenta,
        tipoVenta: venta.tipoVenta,
        subtotalUsd: venta.subtotalUsd || 0,
        ivaUsd: venta.ivaUsd || 0,
        descuentoUsd: venta.descuentoUsd || 0,
        totalUsd: venta.totalUsd || 0,
        subtotalBs: venta.subtotalBs || 0,
        ivaBs: venta.ivaBs || 0,
        descuentoBs: venta.descuentoBs || 0,
        totalBs: venta.totalBs || 0,
        costoTotalUsd: venta.costoTotalUsd || 0,
        gananciaNetaUsd: venta.gananciaNetaUsd || 0,
        margenGananciaPorcentaje: venta.margenGananciaPorcentaje || 0,
        estado: venta.estado,
        productos: venta.productos,
        observaciones: venta.observaciones,
        idCliente: venta.idCliente,
        clienteNombre: clienteNombre,
        idVendedor: venta.idVendedor,
        vendedorNombre: vendedorNombre,
        idTipoCredito: venta.idTipoCredito || null,
        metodoPago: 'Cargando...',
        pagos: [],
        detalles: venta.detalles || [],
        cantidadTotal: venta.cantidadTotal || 0,
        cargandoPago: false
      };
    },

    normalizarPago(pago) {
      return {
        idPago: pago.idPago,
        idVenta: pago.idVenta,
        idCuota: pago.idCuota,
        fechaPago: pago.fechaPago,
        montoUsd: pago.montoUsd || 0,
        montoBs: pago.montoBs || 0,
        tipoPago: pago.tipoPago,
        numeroRecibo: pago.numeroRecibo,
        observaciones: pago.observaciones
      };
    },

    async cargarDatosMaestros() {
      try {
        // ✅ Cargar clientes y vendedores EN PARALELO (más rápido)
        const [clientesRes, vendedoresRes, metodosRes] = await Promise.all([
          obtenerClientes(),
          obtenerVendedores(),
          obtenerMetodosPagoActivos()
        ]);

        if (clientesRes.success && clientesRes.data) {
          clientesRes.data.forEach(cliente => {
            const nombreCompleto = `${cliente.nombre} ${cliente.apellido || ''}`.trim();
            this.clientesMap.set(cliente.idCliente, nombreCompleto);
            this.clientesFullMap.set(cliente.idCliente, cliente);
          });
          this.clientesUnicos = clientesRes.data.map(c => ({
            idCliente: c.idCliente,
            nombreCompleto: `${c.nombre} ${c.apellido || ''}`.trim()
          }));
        }

        if (vendedoresRes.success && vendedoresRes.data) {
          vendedoresRes.data.forEach(vendedor => {
            const nombreCompleto = `${vendedor.nombre} ${vendedor.apellido || ''}`.trim();
            this.vendedoresMap.set(vendedor.idVendedor, nombreCompleto);
          });
          this.vendedoresUnicos = vendedoresRes.data.map(v => ({
            idVendedor: v.idVendedor,
            nombreCompleto: `${v.nombre} ${v.apellido || ''}`.trim()
          }));
        }

        if (metodosRes.success) {
          this.metodosPago = metodosRes.data || [];
        }
      } catch (e) {
        console.error('Error cargando datos maestros:', e);
      }
    },

    getTipoVentaClasses(tipo, modal = false) {
      const clases = {
        'contado': modal ? 'bg-emerald-500/30 text-emerald-100' : 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-300',
        'credito': modal ? 'bg-amber-500/30 text-amber-100' : 'bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-300'
      };
      const tipoLower = tipo?.toLowerCase();
      return clases[tipoLower] || (modal ? 'bg-gray-500/30 text-gray-100' : 'bg-gray-100 text-gray-800 dark:bg-gray-900/30 dark:text-gray-300');
    },
    
    getMetodoPagoIcon(metodo) {
      if (!metodo) return 'mdi:credit-card-off-outline';
      const m = String(metodo).toLowerCase();
      if (m.includes('efectivo')) return 'mdi:cash';
      if (m.includes('pago móvil') || m.includes('pago movil')) return 'mdi:cellphone';
      if (m.includes('tarjeta') || m.includes('punto')) return 'mdi:credit-card';
      if (m.includes('transferencia') || m.includes('zelle')) return 'mdi:bank-transfer';
      if (m.includes('cachea') || m.includes('cashea')) return 'mdi:lightning-bolt';
      if (m.includes('empresa') || m.includes('corporativo')) return 'mdi:domain';
      return 'mdi:credit-card';
    },
    
    formatNumber(v) { return v === null || v === undefined ? '0.00' : parseFloat(v).toFixed(2); },
    formatFecha(f) { if (!f) return '--/--/----'; return new Date(f).toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' }); },
    formatFechaCompleta(fecha) {
      if (!fecha) return '—';
      return new Date(fecha).toLocaleDateString('es-ES', { 
        weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' 
      });
    },

    formatearTipoVentaConCredito(tipo, idTipoCredito) {
      if (!tipo) return 'CONTADO';
      const t = tipo.toString().toUpperCase();
      if (t === 'CREDITO' || t === 'CRÉDITO' || t === '2') {
        const idStr = (idTipoCredito || '').toString().toUpperCase();
        if (idStr.includes('CAS') || idStr.includes('CACHEA')) return 'CASHEA';
        if (idStr.includes('EMP') || idStr.includes('CORP')) return 'EMPRESA';
        return 'CRÉDITO';
      }
      return 'CONTADO';
    },

    formatearMetodoPagoVenta(venta) {
      if (!venta) return '—';
      
      const mp = venta.metodoPago || venta.tipoPago || venta.tipo_pago || 
                 venta.formaPago || venta.forma_pago || venta.metodo_pago || 
                 venta.idMetodoPago;

      if (mp && mp !== 'Cargando...' && mp !== 'Sin pagos' && mp !== 'Error' && mp !== '—') {
        return mp.toString().toLowerCase();
      }
      
      const t = (venta.tipoVenta || '').toUpperCase();
      if (t.includes('CREDITO') || t.includes('CRÉDITO')) {
        const idCredito = venta.idTipoCredito || venta.id_tipo_credito || venta.tipoCreditoId;
        const idStr = (idCredito || '').toString().toUpperCase();
        if (idStr === 'CAS-001' || idStr.includes('CACHEA')) return 'CASHEA';
        if (idStr === 'EMPRESA' || idStr === 'CORP' || idStr.includes('EMP')) return 'EMPRESA';
        return 'CRÉDITO';
      }

      if (t.includes('CONTADO')) {
        return 'efectivo';
      }
      
      return '—';
    },
    
    getEstadoClasses(e) {
      const c = { 
        'Pagada': 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300', 
        'Pendiente': 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-300', 
        'Cancelada': 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-300',
        'Completada': 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300',
        'Anulada': 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-300',
        'Activa': 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300'
      };
      return c[e] || 'bg-gray-100 text-gray-800';
    },
    
    truncarTexto(t, l) { if (!t) return ''; return t.length <= l ? t : t.substring(0, l) + '...'; },
    sumarPagos(venta) {
      if (!venta.pagos || venta.pagos.length === 0) return 0;
      return venta.pagos.reduce((total, pago) => total + (parseFloat(pago.montoUsd) || 0), 0);
    },
    esVentaCredito(venta) {
      if (!venta.tipoVenta) return false;
      const t = venta.tipoVenta.toString().toLowerCase();
      return t.includes('credito') || t.includes('crédito') || venta.idTipoCredito;
    },
    calcularTotalGeneral() { return this.ventas.reduce((t, v) => t + (v.totalUsd || 0), 0); },
    calcularTotalProductos() { 
      return this.ventas.reduce((t, v) => t + (v.cantidadTotal || 0), 0); 
    },

    tieneIva(venta) {
      if (!venta) return false;
      const ivaUsd = parseFloat(venta.ivaUsd) || 0;
      const ivaBs = parseFloat(venta.ivaBs) || 0;
      return ivaUsd > 0 || ivaBs > 0;
    },
    
    async cargarVentas() {
      try {
        this.cargando = true;
        const res = await obtenerVentas();
        if (res.success) {
          this.ventas = (res.data || [])
            .map(v => this.normalizarVenta(v))
            .sort((a, b) => new Date(b.fechaVenta) - new Date(a.fechaVenta));
          this.filtrarVentas();
          // ✅ Cargar pagos en background (no bloquea)
          this.cargarPagosDeVentas();
        } else {
          this.toast.error(res.error || 'No se pudieron cargar las ventas');
        }
      } catch (e) { 
        console.error(e); 
        this.toast.error('No se pudieron cargar las ventas'); 
      } finally { 
        this.cargando = false; 
      }
    },
    
    // ✅ OPTIMIZADO: Carga los pagos EN PARALELO con Promise.all
    async cargarPagosDeVentas() {
      if (!this.ventas.length) return;
      
      this.cargandoPagos = true;

      // Crear un array de promesas (una por venta)
      const promesas = this.ventas.map(async (v) => {
        try {
          v.cargandoPago = true;
          const res = await obtenerPagosPorVenta(v.idVenta);
          
          if (res.success && res.data?.length) { 
            v.pagos = res.data.map(pago => this.normalizarPago(pago));
            
            const vTipo = (v.tipoVenta || '').toUpperCase();
            if (vTipo.includes('CREDITO') || vTipo.includes('CRÉDITO')) {
              const idC = (v.idTipoCredito || v.id_tipo_credito || '').toString().toUpperCase();
              let label = 'CRÉDITO';
              if (idC.includes('CAS') || idC.includes('CACHEA')) label = 'CASHEA';
              else if (idC.includes('EMP') || idC.includes('CORP')) label = 'EMPRESA';
              
              const primerPago = v.pagos[0];
              const mp = (primerPago?.tipoPago || 'efectivo').toLowerCase();
              v.metodoPago = `${label} + ${mp}`;
            } else {
              const ultimoPago = v.pagos[v.pagos.length - 1];
              v.metodoPago = (ultimoPago?.tipoPago || 'efectivo').toLowerCase();
            }
          } else { 
            v.pagos = []; 
            const vTipo = (v.tipoVenta || '').toUpperCase();
            if (vTipo.includes('CREDITO') || vTipo.includes('CRÉDITO')) {
              const idC = (v.idTipoCredito || v.id_tipo_credito || '').toString().toUpperCase();
              if (idC.includes('CAS') || idC.includes('CACHEA')) v.metodoPago = 'CASHEA';
              else if (idC.includes('EMP') || idC.includes('CORP')) v.metodoPago = 'EMPRESA';
              else v.metodoPago = 'CRÉDITO';
            } else {
              v.metodoPago = 'efectivo'; 
            }
          }
        } catch (e) { 
          console.error(`Error cargando pagos para venta ${v.idVenta}:`, e);
          v.pagos = []; 
          v.metodoPago = 'Error'; 
        } finally { 
          v.cargandoPago = false; 
        }
      });

      // Ejecutar TODAS las promesas en paralelo
      await Promise.all(promesas);
      
      // Refrescar la vista una sola vez al final
      this.filtrarVentas();
      this.cargandoPagos = false;
    },
    
    async imprimirVenta(venta) {
      try {
        this.toast.info("Preparando ticket...");
        const tasaRes = await obtenerTasaActiva();
        const tasa = tasaRes.success ? tasaRes.data : null;
        const cliente = this.clientesFullMap.get(venta.idCliente) || { nombre: venta.clienteNombre || '' };
        const usuario = { nombre: venta.vendedorNombre || '' };
        
        let ventaParaImprimir = { ...venta };
        let productos = venta.detalles || [];
        
        const fullVentaRes = await obtenerVentaConRelaciones(venta.idVenta);
        if (fullVentaRes.success && fullVentaRes.data) {
          ventaParaImprimir = { ...ventaParaImprimir, ...fullVentaRes.data };
          productos = fullVentaRes.data.ventaDetalles || fullVentaRes.data.detalles || productos;
        }
        
        imprimirFactura(ventaParaImprimir, cliente, usuario, tasa, productos);
      } catch (error) {
        console.error("Error al imprimir la venta:", error);
        this.toast.error("Error al imprimir el ticket de venta");
      }
    },

    async imprimirFacturaDigital(venta) {
      if (!venta || !venta.idVenta) {
        this.toast.error('Venta inválida');
        return;
      }

      try {
        this.toast.info('Generando factura digital...');

        const res = await obtenerFacturaDigital(venta.idVenta);

        if (!res.success || !res.data) {
          throw new Error(res.error || 'No se pudo obtener la factura digital');
        }

        await abrirFacturaPdf(venta.idVenta);

        this.toast.success(`Factura ${venta.numeroFactura} generada`);
      } catch (error) {
        console.error('Error generando factura digital:', error);
        this.toast.error(error.message || 'Error al generar la factura digital');
      }
    },
    
    async cargarDetallesVenta(venta) {
      try {
        const res = await obtenerVentaConRelaciones(venta.idVenta);
        if (res.success && res.data) {
          venta.detalles = res.data.detalles || [];
          return true;
        }
        return false;
      } catch (e) {
        console.error('Error cargando detalles:', e);
        return false;
      }
    },
    
    async refreshVentas() { 
      // ✅ Recarga en paralelo
      await Promise.all([
        this.cargarDatosMaestros(),
        this.cargarVentas()
      ]);
      this.toast.success('Lista actualizada'); 
    },
    
    filtrarVentas() {
      let f = [...this.ventas];
      if (this.filtro.numeroFactura) f = f.filter(v => v.numeroFactura?.toLowerCase().includes(this.filtro.numeroFactura.toLowerCase()));
      if (this.filtro.idCliente) f = f.filter(v => v.idCliente == this.filtro.idCliente);
      if (this.filtro.idVendedor) f = f.filter(v => v.idVendedor == this.filtro.idVendedor);
      if (this.filtro.metodoPago) f = f.filter(v => v.metodoPago === this.filtro.metodoPago);
      if (this.filtro.estado) f = f.filter(v => v.estado === this.filtro.estado);
      const fdStr = this.filtro.fechaDesde;
      const fhStr = this.filtro.fechaHasta;

      if (fdStr && !fhStr) {
        const fd = new Date(fdStr + 'T00:00:00');
        const fh = new Date(fdStr + 'T23:59:59');
        f = f.filter(v => {
          const vDate = new Date(v.fechaVenta);
          return vDate >= fd && vDate <= fh;
        });
      } else {
        if (fdStr) { 
          const fd = new Date(fdStr + 'T00:00:00'); 
          f = f.filter(v => new Date(v.fechaVenta) >= fd); 
        }
        if (fhStr) { 
          const fh = new Date(fhStr + 'T23:59:59'); 
          f = f.filter(v => new Date(v.fechaVenta) <= fh); 
        }
      }
      this.ventasFiltradas = f; this.paginaActual = 1;
    },
    
    toggleFiltros() { this.mostrarFiltros = !this.mostrarFiltros; },
    resetFiltros() { 
      const today = new Date().toLocaleDateString('sv-SE');
      this.filtro = { 
        numeroFactura: '', 
        idCliente: '', 
        idVendedor: '', 
        metodoPago: '', 
        estado: '', 
        fechaDesde: today, 
        fechaHasta: '' 
      }; 
      this.filtrarVentas(); 
      this.paginaActual = 1; 
      this.toast.info('Filtros limpiados'); 
    },
    aplicarFiltrosRapidos() { this.filtrarVentas(); this.mostrarFiltros = false; this.toast.success('Filtros aplicados'); },
    paginaAnterior() { if (this.paginaActual > 1) { this.paginaActual--; window.scrollTo({ top: 0, behavior: 'smooth' }); } },
    paginaSiguiente() { if (this.paginaActual < this.totalPaginas) { this.paginaActual++; window.scrollTo({ top: 0, behavior: 'smooth' }); } },
    irAPagina(p) { if (p >= 1 && p <= this.totalPaginas) { this.paginaActual = p; window.scrollTo({ top: 0, behavior: 'smooth' }); } },
    
    async verDetalles(v) {
      this.ventaSeleccionada = { ...v };
      await this.cargarDetallesVenta(this.ventaSeleccionada);
      this.tabActiva = 'resumen';
      this.modalDetalles.show = true;
    },
    cerrarModalDetalles() { this.modalDetalles.show = false; setTimeout(() => { this.ventaSeleccionada = null; }, 300); },
    
    abrirModalPago(venta) { this.ventaParaPago = venta; this.modalPago.show = true; },
    cerrarModalPago() { this.modalPago.show = false; this.ventaParaPago = null; },
    
    async confirmarPago() {
      if (!this.ventaParaPago) return;
      this.procesandoPago = true;
      try {
        const res = await actualizarVenta(this.ventaParaPago.idVenta, { 
          ...this.ventaParaPago, 
          estado: 'Pagada' 
        });
        if (res.success) {
          await this.cargarVentas();
          if (this.ventaSeleccionada?.idVenta === this.ventaParaPago.idVenta) this.ventaSeleccionada.estado = 'Pagada';
          this.cerrarModalPago();
          this.toast.success('Venta marcada como pagada');
          notificarVenta('Pago confirmado', `Venta ${this.ventaParaPago?.numeroFactura}`, `Cliente: ${this.ventaParaPago?.clienteNombre || ''}`);
        } else throw new Error(res.error);
      } catch (e) { 
        console.error(e);
        this.toast.error('No se pudo actualizar'); 
      } finally { 
        this.procesandoPago = false; 
      }
    },
    
    abrirModalEliminar(venta) { this.ventaParaEliminar = venta; this.modalEliminar.show = true; },
    cerrarModalEliminar() { this.modalEliminar.show = false; this.ventaParaEliminar = null; },
    
    async confirmarEliminar() {
      if (!this.ventaParaEliminar) return;
      this.procesandoEliminar = true;
      try {
        const res = await eliminarVentaApi(this.ventaParaEliminar.idVenta);
        if (res.success) {
          if (this.modalDetalles.show && this.ventaSeleccionada?.idVenta === this.ventaParaEliminar.idVenta) this.cerrarModalDetalles();
          await this.cargarVentas();
          this.cerrarModalEliminar();
          this.toast.success('Venta eliminada correctamente');
          notificarVenta('Eliminada', `Venta ${this.ventaParaEliminar?.numeroFactura}`, `Cliente: ${this.ventaParaEliminar?.clienteNombre || ''}`);
        } else throw new Error(res.error);
      } catch (e) { 
        this.toast.error(e.message || 'No se pudo eliminar'); 
      } finally { 
        this.procesandoEliminar = false; 
      }
    }
  }
};
</script>

<style scoped>
.text-lexend { font-family: 'Lexend', sans-serif; }
.custom-scrollbar::-webkit-scrollbar { width: 6px; height: 6px; }
.custom-scrollbar::-webkit-scrollbar-track { background: transparent; }
.custom-scrollbar::-webkit-scrollbar-thumb { background: #e2e8f0; border-radius: 10px; }
.dark .custom-scrollbar::-webkit-scrollbar-thumb { background: #334155; }

@keyframes zoomIn {
  from { opacity: 0; transform: scale(0.95); }
  to { opacity: 1; transform: scale(1); }
}
.animate-zoomIn { animation: zoomIn 0.2s ease-out; }

@keyframes fadeInUp {
  from { opacity: 0; transform: translateY(15px); }
  to { opacity: 1; transform: translateY(0); }
}
.animate-fadeInUp { animation: fadeInUp 0.4s ease-out forwards; }
.delay-100 { animation-delay: 0.1s; }

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}
.animate-fadeIn { animation: fadeIn 0.3s ease-out; }

.transition-all { transition: all 0.3s ease; }
html { scroll-behavior: smooth; }

@media (max-width: 640px) {
  button { min-height: 44px; min-width: 44px; }
}
</style>